import React, { useState } from "react";
import "../styles/pageContent.css";
import CategoryBar from "../components/CategoryBar";
import AuctionGrid from "../components/AuctionGrid";
import FilterBar from "../components/FilterBar";

function Auction() {
  const [filter, setFilter] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="page-container">
      <h1>Live Auctions</h1>
      <p>Bid on your favorite products.</p>
      <CategoryBar onCategoryClick={handleCategoryClick} />
      <FilterBar onFilterChange={setFilter} />
      <AuctionGrid filter={filter} category={selectedCategory} />
    </div>
  );
}

export default Auction; // ✅ Required for default import in App.js
